'use client'
import { useWalletBookContext, getWalletLinks } from '@dynamic-labs/wallet-book';
import { parseWalletLinks } from '../../../../utils/functions/parseWalletLinks/parseWalletLinks.js';
import { getBrowserIcon } from '../../../../shared/utils/functions/getBrowserIcon/getBrowserIcon.js';

const useWalletDownloadLinks = (walletConnector) => {
    const { walletBook } = useWalletBookContext();
    if (!walletConnector) {
        return [];
    }
    const walletLinks = getWalletLinks(walletBook, walletConnector.key);
    const { currentDesktopUrl, userBrowser } = parseWalletLinks(walletLinks);
    if (userBrowser && currentDesktopUrl) {
        return [
            {
                Icon: getBrowserIcon(userBrowser),
                key: userBrowser,
                link: currentDesktopUrl,
                name: userBrowser,
            },
        ];
    }
    return Object.entries(walletLinks)
        .filter(([, link]) => link !== '')
        .filter(([name]) => name !== 'ios' && name !== 'android')
        .map(([name, link]) => ({
        Icon: getBrowserIcon(name),
        key: name,
        link: link,
        name: name,
    }));
};

export { useWalletDownloadLinks };
